<div class="title" mat-dialog-title>{{ configScreen ? ('printerSetup.title' | translate) : description }}</div>

<mat-dialog-content>

  <!-- Step 1: Select Printer -->
  <div class="dialog-options-container" *ngIf="!configScreen">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'printerSetup.loading' | translate }}</p>
    </div>

    <div *ngIf="!loading && printers.length === 0" class="no-printers">
      <p>{{ 'printerSetup.noPrinters' | translate }}</p>
    </div>

    <mat-selection-list
      *ngIf="!loading && printers.length > 0"
      [(ngModel)]="autoPrint.selectedPrinters"
      [multiple]="false"
    >
      <mat-list-option *ngFor="let printer of printers" [value]="printer">
        <div class="printer-popup">
          <img [src]="printerLogos[printer.manufacturer] || 'assets/star.png'" alt="{{ printer.manufacturer }} logo"
               class="printer-img"/>
          <div class="printer-info">
            <h3 class="manufacturer">{{ printer.manufacturer }}</h3>
            <p class="ip">IP: {{ printer.ip }}</p>
          </div>
        </div>
      </mat-list-option>
    </mat-selection-list>
  </div>

  <!-- Step 2: Configure Print Settings -->
  <div class="dialog-options-container" *ngIf="configScreen">

    <!-- Print Mode Toggle -->
    <div class="print-mode-toggle">
      <mat-button-toggle-group
        [(ngModel)]="autoPrint.autoPrint"
        aria-label="Print Mode"
        appearance="legacy"
        class="toggle-group"
      >
        <mat-button-toggle [value]="false">{{ 'printerSetup.manual' | translate }}</mat-button-toggle>
        <mat-button-toggle [value]="true">{{ 'printerSetup.autoPrint' | translate }}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <p class="mode-description">
      <span *ngIf="!autoPrint.autoPrint">{{ 'printerSetup.manualDesc' | translate }}</span>
      <span *ngIf="autoPrint.autoPrint">{{ 'printerSetup.autoPrintDesc' | translate }}</span>
    </p>

    <!-- Print Settings Card -->
    <div class="settings-card">
      <p class="settings-card-title">{{ 'printerSetup.printSettings' | translate }}</p>

      <!-- Printer Model — drives the ESC/POS dialect the backend emits.
           Same dropdown as the Global Printers screen; picking the wrong
           model produced the missing-cut + leading-"a" bugs on Epson
           TM-L90 + XK200L clones. Default empty = auto-detect from the
           saved Printer document so existing KDS sessions are unchanged. -->
      <div class="settings-row">
        <label class="field-label">Printer Model</label>
        <mat-select [ngModel]="autoPrint.printerModel"
                    (ngModelChange)="onPrinterModelChange($event)"
                    class="field-select">
          <mat-option *ngFor="let opt of printerModelOptions" [value]="opt.value">{{ opt.label }}</mat-option>
        </mat-select>
      </div>

      <div class="settings-row">
        <label class="field-label">{{ 'printerSetup.labelStyle' | translate }}</label>
        <mat-select [(ngModel)]="autoPrint.labelVersion" class="field-select">
          <mat-option *ngFor="let opt of labelVersionOptions" [value]="opt.value">{{ opt.label }}</mat-option>
        </mat-select>
      </div>

      <div class="settings-row sub-option" *ngIf="autoPrint.labelVersion === 'v3'">
        <label class="field-label">{{ 'printerSetup.paperSize' | translate }}</label>
        <mat-select [(ngModel)]="autoPrint.paperSize" class="field-select">
          <mat-option *ngFor="let opt of paperSizeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
        </mat-select>
      </div>

      <div class="settings-row">
        <label class="field-label">{{ 'printerSetup.printPaidOnly' | translate }}</label>
        <mat-slide-toggle [(ngModel)]="autoPrint.filterPaid"></mat-slide-toggle>
      </div>
    </div>

    <!-- Auto-Print Filters -->
    <div *ngIf="autoPrint.autoPrint" class="auto-print-filters">
      <div class="filter-section">
        <label class="field-label">{{ 'printerSetup.categories' | translate }}</label>
        <ng-multiselect-dropdown
          class="dropdown-filter-selector"
          [placeholder]="'Select categories...'"
          [settings]="categoryDropdownSettings"
          [data]="categories"
          [(ngModel)]="autoPrint.categories"
          (onSelect)="onFilterCategorySelect($event)"
          (onDeSelect)="onFilterCategoryDeSelect($event)">
        </ng-multiselect-dropdown>
      </div>

      <div class="filter-section">
        <label class="field-label">{{ 'printerSetup.items' | translate }}</label>
        <ng-multiselect-dropdown
          class="dropdown-filter-selector"
          [placeholder]="'Select items...'"
          [settings]="itemDropdownSettings"
          [data]="items"
          [(ngModel)]="autoPrint.items"
          (onSelect)="onFilterItemSelect($event)"
          (onDeSelect)="onFilterItemDeSelect($event)">
        </ng-multiselect-dropdown>
      </div>

      <div class="filter-section">
        <label class="field-label">{{ 'printerSetup.modifiers' | translate }}</label>
        <ng-multiselect-dropdown
          class="dropdown-filter-selector"
          [placeholder]="'Select modifiers...'"
          [settings]="modifierDropdownSettings"
          [data]="modifiers"
          [(ngModel)]="autoPrint.modifiers"
          (onSelect)="onFilterModifierSelect($event)"
          (onDeSelect)="onFilterModifiersDeSelect($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>

  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="button-container">
    <button mdbBtn color="danger" block="true" class="my-4 mr-2 action-button" (click)="close()">
      {{ 'button.cancel' | translate }}
    </button>
    <button
      mdbBtn
      [disabled]="loading || !autoPrint.selectedPrinters.length"
      color="info"
      block="true"
      class="my-4 action-button"
      (click)="submit()"
    >
      {{ button_text }}
    </button>
  </div>
</mat-dialog-actions>
